export const OPERO_BRAND = {
  name: "Opero",
  fullName: "OPERO Task Management Platform",
  tagline: "AI-Powered Task Management",
  parentCompany: "Digiits",
  domain: "opero.team",
  appDomain: "app.opero.team",
  adminDomain: "admin.opero.team",
  contactEmail: "corporate@digiits.com",
  website: "digiits.com",
  copyright: (year?: number) =>
    `\u00A9 ${year ?? new Date().getFullYear()} Opero by Digiits. All rights reserved.`,
} as const;
